import Section from './ColorOfTheYearSection'
import isEmpty from './ColorOfTheYearIsEmpty'

export default { Section, isEmpty }
